import React, { useState } from 'react';
import { FlatList, Image } from 'react-native';
import { view_styles } from '../../constants/styles';
import { Icons } from '../../Components';
import Colors from '../../constants/colors';
import type { EventProps, PublicPlayerProps, SquarePrizeProps, SquareProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type PrizeCardProps = {
    square_prizes:SquarePrizeProps[]
    event?:EventProps,
    hidden?:boolean,
    disable_collapse?:boolean,
    squares: SquareProps[],
    players:PublicPlayerProps[]
}

const PrizeCard = ({ hidden, disable_collapse, event, square_prizes, players, squares }:PrizeCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);

    const renderPrizes = (data: { item:SquarePrizeProps, index:number }) => {
        const square = squares.find(s => s.sq_square_id == data.item.sq_square_id)
        const winner = players.find(p => p.player_id == data.item.winner_id)
        if(!square){ return <></> }
        return (
            <View style={{ ...view_styles.body_row, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                <Image
                    source={{ uri: data.item.image.url }}
                    style={{ height: 40, width:40, borderRadius:4 }}
                    resizeMode='cover'
                />
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>{data.item.description}</Text>
                    {winner ?
                    <Text style={{marginTop:3}} size={12} color={Colors.incentive.gold} weight={'bold'}>Winner: @{winner.username}</Text>
                    :<></>}
                </View>
                {data.item.status == 'active' ?
                <View style={{ padding:10 }}>
                    <Icons.UnbidSquare color={event?.home?.primary_color} secondary_color={event?.away?.primary_color} size={20} />
                    <View style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
                        <View style={{ backgroundColor:Colors.shades.white, borderRadius:4, height:25, width:25, justifyContent:'center', alignItems:'center' }}>
                            <Text theme='h1'>?</Text>
                        </View>
                    </View>
                </View>
                :data.item.status == 'awarded'?
                <View style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                    {winner ?
                    <Image
                        source={{ uri: winner.profile_pic && winner.profile_pic != '' ? winner.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:40, width:40, borderRadius:4, marginRight:10 }}
                        resizeMode='cover'
                    />
                    :<></>}
                    <View>
                        <Icons.UnbidSquare color={Colors.shades.shade100} secondary_color={Colors.shades.shade100} size={20} />
                        <View style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
                            <Text>{square.square_score_x}, {square.square_score_y}</Text>
                        </View>
                    </View>
                </View>
                :<></>}
            </View>
        )
    }

    if(hidden){ return <></> }

    return (
        <View float style={{ minWidth:350, borderRadius:0 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center', backgroundColor:C.views.header, borderRadius:0 }} onPress={() => setExpanded(!expanded)}>
                <Icons.AwardRibbonIcon size={18} color={C.text.gold} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>HIDDEN PRIZES</Text>
                    <Text style={{ marginTop:3 }} theme="description">This board contains some hidden prizes! Check them out here!</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} size={8} color={C.text.h1} />
                :<></>}
            </Button>
            {expanded ?
            <View transparent style={view_styles.section_body}>
                <FlatList
                    data={square_prizes.sort((a,b) => parseInt(a.square_prize_id) - parseInt(b.square_prize_id))}
                    renderItem={renderPrizes}
                    keyExtractor={(item) => item.square_prize_id.toString()}
                />
                 <View transparent style={{ marginTop:10, flexDirection:'row', alignItems:'center', borderRadius:8, backgroundColor:Colors.incentive.gold_faded, padding:10 }}>
                    <Icons.AlertIcon color={C.text.h1} size={16} />
                    <View transparent style={{ flex:1, marginLeft:5 }}>
                        <Text theme='h2'>Prizes are hidden behind random squares on the board. End up with this square after the auction period and win the prize!</Text>
                        <Text style={{ marginTop:3 }} theme='description'>Square will be visible once the auction period ends</Text>
                    </View>
                </View>
            </View>
            :<></>}
        </View>
    )
}

export default PrizeCard 